module.exports = __webpack_public_path__ + "img/logo.27b99f4b.png";